/* eslint-disable no-unused-vars */
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { ROUTES } from '../../../routes';
import { PRIMARY } from '../../../shared/colors';
import { ToString } from '../../../shared/constants';
import { signUp } from '../network';

export const RegistrationForm = () => {
  const router = useHistory();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Form
      layout='vertical'
      form={form}
      labelCol={{ span: 15 }}
      wrapperCol={{ span: 25 }}
      initialValues={{}}
      scrollToFirstError
      onFinish={async (dataForm) => {
        setIsLoading(true);

        await signUp(dataForm)
          .then(({ statusCode, data }) => {
            if (statusCode.toString()[0] === '2') {
              router.push(ROUTES.SIGNIN);
            } else {
              notification.error({
                message: `Erreur ${statusCode}`,
                description: ToString(data),
              });

              setIsLoading(false);
            }
          })
          .catch((err) => {
            notification.error({
              message: 'Erreur',
              description: err.message,
            });
          });
      }}
    >
      <Form.Item
        label='Nom'
        name='nom'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre nom',
          },
        ]}
      >
        <Input placeholder='nom' />
      </Form.Item>

      <Form.Item
        label='Prénom'
        name='prenom'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre prénom',
          },
        ]}
      >
        <Input placeholder='prénom' />
      </Form.Item>

      <Form.Item
        label='Email'
        name='email'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre mail',
          },
          {
            type: 'email',
            message: "Le format de l'email n'est pas respecté",
          },
        ]}
      >
        <Input placeholder='email' />
      </Form.Item>
      <Form.Item
        label='Téléphone (avec indicatif)'
        name='mobile'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre numéro de téléphone',
          },
        ]}
      >
        <Input placeholder='Téléphone' />
      </Form.Item>

      <Form.Item label='Adresse' name='adresse'>
        <Input placeholder='adresse' />
      </Form.Item>

      <Form.Item label='Nationalité' name='nationalite'>
        <Input placeholder='nationalite' />
      </Form.Item>

      <Form.Item
        label='Password'
        name='password'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre mot de passe',
          },
        ]}
      >
        <Input.Password placeholder='password' />
      </Form.Item>

      <Form.Item>
        <Button
          type='primary'
          htmlType='submit'
          loading={isLoading}
          size='large'
          style={{
            width: '100%',
            backgroundColor: PRIMARY,
            borderColor: 'transparent',
          }}
        >
          Créer son compte
        </Button>
      </Form.Item>
    </Form>
  );
};
